import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import TimePicker from 'rc-time-picker';
import TextInput from '../common/TextInput';
import Button from '../common/Button';
import CustomScroll from 'react-custom-scroll';
import { map, keyBy, cloneDeep, each, capitalize, findIndex } from 'lodash';
import { FormGroup, FormControl, Modal } from 'react-bootstrap';
import { sumByObject, checkDateTimeInvalid, isGreaterThanStartDate } from '../../helpers';
import { jobServiceStatuses } from '../../constants/staticData';
import ToastMessage from '../common/ToastMessage';
import Select from '../Results/Select';
import CustomModal from '../common/CustomModal';
import PageLoader from "../common/PageLoader";
import ToggleSwitch from "@trendmicro/react-toggle-switch";
import { isNull } from 'util';

export default class QuotesView extends Component {
  constructor(props) {
    super(props);
    let userbookingRequestServices = cloneDeep(keyBy(props.requestDetails.userbookingrequest_services, 'serviceId'));
    let quotesListByServiceId = cloneDeep(keyBy(props.requestDetails.quotesList, 'serviceId'));
    each(userbookingRequestServices, (service) => {
      service.isValid = true;
      service.isValidDescription = true;
      if (quotesListByServiceId && quotesListByServiceId[service.serviceId]) {
        service.amount = quotesListByServiceId[service.serviceId].amount || 0;
        service.jobdetailstatusId = quotesListByServiceId[service.serviceId].jobdetailstatusId || 0;
        service.status = true;
      }
    });
    this.state = {
      payAtShopSwitch: false,
      isPaymentButtonLoading: false,
      showDeclineModal: false,
      selectedStartDate: props.requestDetails.jobStartDatetime || moment(props.requestDetails.userPrefferedDatetime) || null,
      selectedStartTime: props.requestDetails.jobStartDatetime || moment(props.requestDetails.userPrefferedDatetime) || null,
      selectedEndDate: props.requestDetails.jobEndDatetime || null,
      selectedEndTime: props.requestDetails.jobEndDatetime || null,
      userbookingRequestServices: userbookingRequestServices,
      quotesGrouped: cloneDeep(props.requestDetails.quotesGrouped),
      submissionError: false,
      inputChanged: false,
      isButtonLoading: false,
      currentMileage: (this.props.requestDetails.garagejobquote && this.props.requestDetails.garagejobquote.servicedAtKms) ? this.props.requestDetails.garagejobquote.servicedAtKms: '',
      selectedServiceId: '',
      garageJobQuoteArr: (this.props.requestDetails.garagejobquote && this.props.requestDetails.garagejobquote.garagejobquotesdetail),
      garageJobQuote: (this.props.requestDetails.garagejobquote && this.props.requestDetails.garagejobquote),
      jobdetailstatusId: '',
      currentMileageError: false,
      addJobeNote: '',
      showAddSubCatModal: false,
      rpairArr: [],
      washArr: [],
      emergencyArr: [],
      modalArr: [],
      subCategoryType: '',
      declineReason: '',
      showDeclineReasonErrTxt: false,
      emptyServicesErr: false,
      sectionLoader: false,
      inProgEditEnable: true,
      isDoneButtonLoading: false,
      statusArray: [],
      adminRemarks: props.requestDetails.adminRemarks  || '',
      isServiceLoaded : false,
      discountAmount : 0,
      amountUpdated: false,
      promotionalOffersMessage: "",
      isOfferApplied: false,
      promotionalOffersIsApproved: false,
      isPriceChanged: false,
      paidInspection:  (this.props.requestDetails.garagejobquote && (this.props.requestDetails.garagejobquote.hasOwnProperty("inspectionamount") > 0)) ? true : false,
      inspectionTotalAmount: (this.props.requestDetails.garagejobquote && this.props.requestDetails.garagejobquote.hasOwnProperty("inspectionamount")) ? this.props.requestDetails.garagejobquote.inspectionamount: 0,
      inspectiondescription: (this.props.requestDetails.garagejobquote && (this.props.requestDetails.garagejobquote.hasOwnProperty("inspectiondescription") && this.props.requestDetails.garagejobquote.inspectiondescription !== isNull)) ? this.props.requestDetails.garagejobquote.inspectiondescription : "",
      showInspDescription: false
    };


    /* 11PM condition for end date - CCWFE-2701  */


    if (typeof props.requestDetails.jobEndDatetime == 'undefined'){
      let selectedEndDate = this.state.selectedStartDate;
      if(selectedEndDate){
        if(moment(selectedEndDate, 'h:mma').isBefore(moment('11:00pm', 'h:mma')) == false){
          selectedEndDate =  moment(selectedEndDate, "DD-MM-YYYY h:mma").add(1, 'days');
        }
        this.state.selectedEndDate = selectedEndDate;
      }
    }

    /* ends */


    this.errors = {
      jobStartDate: false,
      jobStartTime: false,
      jobEndDate: false,
      jobEndTime: false,
      invalidStartTime: false,
      invalidEndTime: false
    };
    this.onPriceChange = this.onPriceChange.bind(this);
    this.onStatusChange = this.onStatusChange.bind(this);
    this.onServiceDescpChange = this.onServiceDescpChange.bind(this);
    this.createQuote = this.createQuote.bind(this);
    this.declineJob = this.declineJob.bind(this);
    this.onQuoteChange = this.onQuoteChange.bind(this);
    this.onDeclineReasonChange = this.onDeclineReasonChange.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleSubCatAdd = this.handleSubCatAdd.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.showServiceDescp = this.showServiceDescp.bind(this);
    this.openCategoryModal = this.openCategoryModal.bind(this);
    this.updateInProgQuotes = this.updateInProgQuotes.bind(this);
    this.applyPromoForUpdatedAmount = this.applyPromoForUpdatedAmount.bind(this);
    this.onChangeInspDesc = this.onChangeInspDesc.bind(this);
    this.onInspecPriceChange = this.onInspecPriceChange.bind(this);
    this.checkInspection = this.checkInspection.bind(this);
    this.showInspectionDesc = this.showInspectionDesc.bind(this);
    this.checkStatusFlag = this.checkStatusFlag.bind(this);
    this.onChangeToggleInsp = this.onChangeToggleInsp.bind(this);
    this.getInspectionInfo = this.getInspectionInfo.bind(this);
  }

  componentWillMount() {
    this.props.actions.getAllServices();
    this.props.actions.getBusinessTax();

  }

  componentDidMount() {
    this.getJobNotes();
    this.getActiveStateArr();
  }

  initializeqouteDetails() {

    // quotesGrouped
  }

  showServiceDescp (e, categoryIndex, type, selectedArr) {
    e.preventDefault();
    let userbookingRequestServices = cloneDeep(this.state.userbookingRequestServices);
    let garageJobQuoteArr = cloneDeep(this.state.garageJobQuoteArr);
    let jobStatus = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
    if (selectedArr && selectedArr.length && (jobStatus != 'waiting')) {
      garageJobQuoteArr.forEach((item) => {
        if ((item.serviceId === categoryIndex)) {
          item.showDescp = !item.showDescp;
        }
      });
       this.setState({garageJobQuoteArr: garageJobQuoteArr});
    }
    else {
      let selectedCatArr = this.state.quotesGrouped[type];
        let index = findIndex(selectedCatArr, { serviceId: categoryIndex });
        selectedCatArr.forEach((item)=>{
          if(item.serviceId === categoryIndex) {
            item.showDescp = !item.showDescp;
          }
        });
      this.setState({ quotesGrouped: this.state.quotesGrouped, userbookingRequestServices: userbookingRequestServices});
    }

  }


  handleCheck(categoryIndex, type, selectedArr) {
    let userbookingRequestServices = cloneDeep(this.state.userbookingRequestServices);
    let garageJobQuoteArr = cloneDeep(this.state.garageJobQuoteArr);
    let jobStatus = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
    if (selectedArr && selectedArr.length && (jobStatus != 'waiting')) {
      garageJobQuoteArr.forEach((item) => {
        if ((item.serviceId === categoryIndex)) {
          item.amount = 0;
          item.isValid = true;
          item.status = !item.status;
          item.isinspectionrequired = !item.status ? false : item.isinspectionrequired;
        }
      });
       this.setState({garageJobQuoteArr: garageJobQuoteArr});
    }
    else {
      let selectedCatArr = this.state.quotesGrouped[type];
      let garageJobQuoteArr = cloneDeep(this.state.garageJobQuoteArr);
        let index = findIndex(garageJobQuoteArr, { serviceId: categoryIndex });
        selectedCatArr.forEach((item)=>{
          if(item.serviceId === categoryIndex) {
            item.status = !item.status;
            item.isinspectionrequired = !item.status ? false : item.isinspectionrequired;
            garageJobQuoteArr[index].isinspectionrequired = !item.status ? false : item.isinspectionrequired;
            userbookingRequestServices[categoryIndex].status = item.status ;
            userbookingRequestServices[categoryIndex].amount = 0;
          }
        });
        // selectedCatArr.splice(index, 1);
        // delete userbookingRequestServices[categoryIndex];
      this.setState({ quotesGrouped: this.state.quotesGrouped, userbookingRequestServices: userbookingRequestServices, garageJobQuoteArr: garageJobQuoteArr});
    }

  }

  handleSubCatAdd (selectedItem) {
    let modalArr = cloneDeep(this.state.modalArr);
    modalArr.forEach((item)=>{
      if(item.id === selectedItem.id) {
        item.toBeAdded = !item.toBeAdded;
        selectedItem.toBeAdded = !selectedItem.toBeAdded;
      }
    });

    this.setState({
      modalArr: modalArr
    });
    // console.log("toBeAdded = ", modalArr);
  }

  updateInProgQuotes () {

    let garageJobQuoteArr = cloneDeep(this.state.garageJobQuoteArr);
    this.setState({
      inProgEditEnable: true,
      garageJobQuoteArr: garageJobQuoteArr
    });
  }

  doneInProgQuotesUpdate (e, jobStatus) {
     this.createQuote(e, jobStatus, false, false, true);
  }

  handleAdd () {
    let modalArr = cloneDeep(this.state.modalArr);
    let quotesGrouped = cloneDeep(this.state.quotesGrouped);
    let garageJobQuoteArr = cloneDeep(this.state.garageJobQuoteArr);
    let userbookingRequestServices = cloneDeep(this.state.userbookingRequestServices);
    let newAddedSubCatArr = modalArr.filter((item)=> item.toBeAdded);
    newAddedSubCatArr.forEach((item) => {
      let Obj = {};
      let userbookingReqSerObj = {};
      Obj = {
        name:item.name,
        amount: 0,
        parent:{id: item.parentId, name: this.state.subCategoryType},
        parentId:item.parentId,
        serviceId:item.id,
        status:true,
        isValid: true,
        isValidDescription: true,
        userbookingrequestId:this.props.requestDetails.userbookingrequestId
      };
      userbookingReqSerObj = {
        amount: 0,
        isValid: true,
        isValidDescription:true,
        status:true,
        name:item.name,
        parent:{id: item.parentId, name: this.state.subCategoryType},
        parentId:item.parentId,
        serviceId:item.id,
        userbookingrequestId:this.props.requestDetails.userbookingrequestId
      };
      userbookingRequestServices[item.id] = userbookingReqSerObj;
      quotesGrouped[this.state.subCategoryType].push(Obj);
      let jobStatus = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
      if (jobStatus != 'waiting') {
        garageJobQuoteArr.push(Obj);
      }
    });
    let jobStatus = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
    if (jobStatus != 'waiting') {
      this.setState({
        quotesGrouped: quotesGrouped,
        garageJobQuoteArr: garageJobQuoteArr,
        showAddSubCatModal: false
      });
    }
    else {
      this.setState({
        quotesGrouped: quotesGrouped,
        garageJobQuoteArr: garageJobQuoteArr,
        userbookingRequestServices: userbookingRequestServices,
        showAddSubCatModal: false
      });
    }
  }

  componentWillReceiveProps(nextProps) {


    this.setState({

      vat:  nextProps.commonReducer && nextProps.commonReducer.taxInfo &&  nextProps.commonReducer.taxInfo.length && nextProps.commonReducer.taxInfo ?  nextProps.commonReducer.taxInfo[0].value: 0,
    })

    if (nextProps.requestDetails && nextProps.requestDetails.garagejobquote) {

      this.setState({
        garageJobQuote: nextProps.requestDetails.garagejobquote
      });
    }
    if (nextProps.commonReducer && nextProps.commonReducer.getAllServices && nextProps.commonReducer.getAllServices.length && ! this.state.isServiceLoaded) {
      this.setState({
        emergencyArr: nextProps.commonReducer.getAllServices[3].sub_services,
        rpairArr: nextProps.commonReducer.getAllServices[2].sub_services,
        washArr: nextProps.commonReducer.getAllServices[0].sub_services,
        isServiceLoaded : true,
        discountAmount: nextProps.requestDetails.garagejobquote.discountAmount
      });
      // console.log("state == ", this.state);
    }
    if (nextProps.requestDetails && nextProps.requestDetails && nextProps.requestDetails.garagejobquote && ! this.state.isServiceLoaded) {
      setTimeout(()=>{
        this.getActiveStateArr();
      }, 2000);
    }

    if( this.state.isOfferApplied){
      this.setState({
        discountAmount: nextProps.commonReducer.discountAmount,
        promotionalOffersMessage:  nextProps.commonReducer.promotionalOffersMessage,
        isOfferApplied: false,
        isPriceChanged: false,
        promotionalOffersIsApproved: nextProps.commonReducer.promotionalOffersIsApproved
      });


    }



    let userbookingRequestServices = cloneDeep(this.state.quotesGrouped);
    map(this.state.quotesGrouped, (categories, key) => {
      map(categories, (category, categoryKey) => {
        category.status = true;
      });
    });

    if (this.state.isButtonLoading && nextProps.requestDetails && nextProps.requestDetails.quotesLoaded) {

      this.setState({
        'isButtonLoading': false,
        'sectionLoader': true,
        discountAmount: nextProps.requestDetails.garagejobquote.discountAmount
      });
    }


    if (this.state.isPaymentButtonLoading && nextProps.commonReducer.paymentConfirmed) {
      this.props.actions.getPostedJobById(this.props.requestDetails.id);

      this.setState({
        'isPaymentButtonLoading': false,
      });
    }



    if(this.props.requestDetails && nextProps.requestDetails && (this.props.requestDetails.id != nextProps.requestDetails.id) ){

      let userbookingRequestServices = cloneDeep(keyBy(nextProps.requestDetails.userbookingrequest_services, 'serviceId'));
    let quotesListByServiceId = cloneDeep(keyBy(nextProps.requestDetails.quotesList, 'serviceId'));
    each(userbookingRequestServices, (service) => {
      service.isValid = true;
      if (quotesListByServiceId && quotesListByServiceId[service.serviceId]) {
        service.amount = quotesListByServiceId[service.serviceId].amount || 0;
        service.jobdetailstatusId = quotesListByServiceId[service.serviceId].jobdetailstatusId || 0;
      }
    });
    this.setState({
      selectedStartDate: nextProps.requestDetails.jobStartDatetime || nextProps.requestDetails.userPrefferedDatetime || null,
      selectedStartTime: nextProps.requestDetails.jobStartDatetime || nextProps.requestDetails.userPrefferedDatetime || null,
      selectedEndDate: nextProps.requestDetails.jobEndDatetime || null,
      selectedEndTime: nextProps.requestDetails.jobEndDatetime || null,
      userbookingRequestServices: userbookingRequestServices,
      quotesGrouped: cloneDeep(nextProps.requestDetails.quotesGrouped)
    });
    const servicedAtKms =  (this.props.requestDetails.garagejobquote && this.props.requestDetails.garagejobquote.servicedAtKms) ? this.props.requestDetails.garagejobquote.servicedAtKms: '';
    if(servicedAtKms != this.state.currentMileage){
      this.setState({currentMileage: servicedAtKms});
    }
  }
//    this.props.actions.getPostedJobById(this.props.requestDetails.id);

  }

  getActiveStateArr () {
      this.setState ({
        'sectionLoader' : false,
        inProgEditEnable: true,
        isDoneButtonLoading: false,
      });
      let qArr = this.props.requestDetails.garagejobquote.garagejobquotesdetail ? this.props.requestDetails.garagejobquote.garagejobquotesdetail : [];
      let qNameArr = [];
      qArr.forEach((gItem) => {
        gItem.status = true;
        gItem.amount = gItem.amount ? gItem.amount : 0;
        qNameArr.push(gItem.name);
      });
      let uQArr = this.props.requestDetails.userbookingrequest_services;
      uQArr.forEach((uItem) => {
        qArr.forEach((gItem) => {
          if (qNameArr.includes(uItem.name)) {
            uItem.flag = true;
            uItem.isValid = true;
          }
          else {
            uItem.flag = false;
            uItem.status = false;
            uItem.amount = 0;
          }
        });
      });

      let notPresentItemArr = [];
      notPresentItemArr = uQArr.filter((item) => {
        return !item.flag;
      });

      qArr = qArr.concat(notPresentItemArr);

      qArr.forEach((gItem) => {
        gItem.isValid = true;
        gItem.isinspectionrequired = gItem.hasOwnProperty('isinspectionrequired')? gItem.isinspectionrequired : false;
      });
      this.setState({
        garageJobQuoteArr: qArr,
        discountAmount: this.props.requestDetails.garagejobquote.discountAmount
      });

  }


  getJobNotes() {
    if(this.props.requestDetails && this.props.requestDetails.garagejobnote && this.props.requestDetails.garagejobnote.jobnotes) {
      this.setState({
        addJobeNote: this.props.requestDetails.garagejobnote.jobnotes
      });
    }
  }

  onPriceChange(quoteAmount, serviceId) {
    let userbookingRequestServices = cloneDeep(this.state.userbookingRequestServices);
    const amount = quoteAmount;
    let jobStatus = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
    if (jobStatus != 'waiting') {

      let garageJobQuoteArr = cloneDeep(this.state.garageJobQuoteArr);
      garageJobQuoteArr.forEach((item) => {
        if ((item.serviceId === serviceId)) {
          item.amount = quoteAmount;
          item.isValid = (quoteAmount > 0 || item.isinspectionrequired) ? true : false;
        }
      });
      this.setState({garageJobQuoteArr: garageJobQuoteArr, discountAmount: 0, isPriceChanged : true, promotionalOffersMessage : "", promotionalOffersIsApproved: false});

    }
    else {
      let garageJobQuoteArr = cloneDeep(this.state.garageJobQuoteArr);
      let index = findIndex(garageJobQuoteArr, { serviceId: serviceId });
      userbookingRequestServices[serviceId].amount = amount;
      userbookingRequestServices[serviceId].isValid = (amount > 0 || garageJobQuoteArr[index].isinspectionrequired) ? true : false;
      this.setState({
        'userbookingRequestServices': userbookingRequestServices,
        isPriceChanged : true,
        promotionalOffersMessage : "",
        promotionalOffersIsApproved: false,
        discountAmount: 0
      });


    }

  }

  onServiceDescpChange (serviceDescp, serviceId) {
    let userbookingRequestServices = cloneDeep(this.state.userbookingRequestServices);
    const serviceTxt = serviceDescp;
    let jobStatus = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();


    if (jobStatus != 'waiting') {
      let garageJobQuoteArr = cloneDeep(this.state.garageJobQuoteArr);
      garageJobQuoteArr.forEach((item) => {
        if ((item.serviceId === serviceId)) {
          item.description = serviceTxt;

          if(serviceTxt != null && serviceTxt.length >= 1001 ){
            item.isValidDescription = false;

          }else{
            item.isValidDescription = true;

          }

        }
      });
      this.setState({garageJobQuoteArr: garageJobQuoteArr});
    }
    else {
      if(serviceTxt != null && serviceTxt.length >= 1001 ){
        userbookingRequestServices[serviceId].isValidDescription = false;

      }else{
        userbookingRequestServices[serviceId].isValidDescription = true;

      }


      userbookingRequestServices[serviceId].description = serviceTxt;
      this.setState({
        'userbookingRequestServices': userbookingRequestServices
      });
    }
  }

  onQuoteChange (text) {
    this.setState({addJobeNote: text});
  }

  onDeclineReasonChange (text) {
    let txtLength = text.length;
    this.setState({
      declineReason: text,
      showDeclineReasonErrTxt: txtLength > 200 ? true : false,
    });
  }

  openCategoryModal (type, selectedArr, serviceType) {

    let newArr = [];
    let rpairArr = cloneDeep(this.state.rpairArr);
    rpairArr[0].sub_services.forEach((item)=>{
        item.isPresent = false;
        item.toBeAdded = false;
    });
    let washArr = cloneDeep(this.state.washArr);
    washArr.forEach((item)=>{
        item.isPresent = false;
        item.toBeAdded = false;
    });

    let emergencyArr = cloneDeep(this.state.emergencyArr);
    emergencyArr.forEach((item)=>{
        item.isPresent = false;
        item.toBeAdded = false;
    });

     if ((serviceType == 'Repair') && rpairArr.length) {
      let grouped = _.mapValues(_.groupBy(rpairArr, 'name'),
                          clist => clist.map(arrayType => _.omit(arrayType, 'name')));

      grouped[type][0].sub_services.forEach((item)=>{

        selectedArr.forEach((selectedItem)=>{
          if(selectedItem.name === item.name) {
            item.isPresent = true;
          }
        });
      });
      newArr = grouped[type][0].sub_services.filter((item) => !item.isPresent);
     }

     if ((serviceType == 'Wash') && washArr.length) {
      washArr.forEach((item)=>{

        selectedArr.forEach((selectedItem)=>{
          if(selectedItem.name === item.name) {
            item.isPresent = true;
          }
        });
      });
      newArr = washArr.filter((item) => !item.isPresent);
     }

     if ((serviceType == 'Emergency Service') && emergencyArr.length) {
      emergencyArr.forEach((item)=>{

        selectedArr.forEach((selectedItem)=>{
          if(selectedItem.name === item.name) {
            item.isPresent = true;
          }
        });
      });
      newArr = emergencyArr.filter((item) => !item.isPresent);
     }

      this.setState({
        modalArr: newArr,
        showAddSubCatModal: true,
        subCategoryType: type
      });
  }

  completeCarService() {
    const serviceTypeId = this.props.requestDetails.serviceId;
    const jobStatus = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
    if (serviceTypeId == 2 && this.state.currentMileage === '' && jobStatus == 'completed') {
       this.setState({'currentMileageError': true});
     } else {
      this.setState({'currentMileageError': false});
      this.props.actions.setServiceKms({
        "jobId": this.props.requestDetails.garagejobquote.id,
        "kms": this.state.currentMileage
      }, this.props.requestDetails.id);
      // if (this.state.selectedServiceId) {
      //   const jobStatus = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
      //   let userbookingRequestServices = cloneDeep(this.state.userbookingRequestServices);
      //   userbookingRequestServices[this.state.selectedServiceId].jobdetailstatusId = this.state.jobdetailstatusId;
      //   this.setState({
      //     'userbookingRequestServices': userbookingRequestServices
      //   });
      //   let nextJobStatus = '';
      //   each(userbookingRequestServices, (service) => {
      //     if (service.jobdetailstatusId != 7) {
      //       nextJobStatus = 'In Progress';
      //     }
      //   });
      //   if (!nextJobStatus) {
      //     nextJobStatus = 'Completed';
      //   }
      //   let updatedQuotesList = cloneDeep(this.props.requestDetails.quotesList);
      //   each(updatedQuotesList, (quote) => {
      //     if (quote.serviceId == this.state.selectedServiceId) {
      //       quote.jobdetailstatusId = this.state.jobdetailstatusId;
      //     }
      //   });
      //   this.props.actions.updateJobStatus(this.props.requestDetails.userbookingrequestId, {
      //     "serviceid": this.state.selectedServiceId,
      //     "statusid": this.state.jobdetailstatusId,
      //     "nextJobStatus": nextJobStatus,
      //     "currentJobStatus": jobStatus,
      //     "updatedQuotesList": updatedQuotesList
      //   });
      //   if (this.state.jobdetailstatusId == 7 && (this.props.requestDetails.garagejobquote && this.props.requestDetails.garagejobquote.id)) {
      //     this.props.actions.setServiceKms({
      //       "jobId": this.props.requestDetails.garagejobquote.id,
      //       "kms": this.state.currentMileage
      //     });
      //   }
      // }
    }
  }
  onStatusChange(serviceId, jobdetailstatusId) {

    const jobStatus = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
    if (this.state.garageJobQuoteArr && this.state.garageJobQuoteArr.length) {
      let garageJobQuoteArr = cloneDeep(this.state.garageJobQuoteArr);
      garageJobQuoteArr.forEach((item) => {
        if(item.serviceId == serviceId) {
          item.jobdetailstatusId = jobdetailstatusId;
        }
      });
      this.setState({
        'garageJobQuoteArr': garageJobQuoteArr
      });

      let nextJobStatus = '';
      each(garageJobQuoteArr, (service) => {
        if (service.jobdetailstatusId != 7) {
          nextJobStatus = 'In Progress';
        }
      });
      if (!nextJobStatus) {
        nextJobStatus = 'Completed';
      }
      let updatedQuotesList = cloneDeep(this.props.requestDetails.garagejobquote.garagejobquotesdetail);
      each(updatedQuotesList, (quote) => {
        if (quote.serviceId == serviceId) {
          quote.jobdetailstatusId = jobdetailstatusId;
        }
      });
      this.props.actions.updateJobStatus(this.props.requestDetails.userbookingrequestId, {
        "serviceids": [serviceId],
        "statusid": jobdetailstatusId,
        "nextJobStatus": nextJobStatus,
        "currentJobStatus": jobStatus,
        "updatedQuotesList": updatedQuotesList
      });
    }
    else {
      let userbookingRequestServices = cloneDeep(this.state.userbookingRequestServices);
      userbookingRequestServices[serviceId].jobdetailstatusId = jobdetailstatusId;
      this.setState({
        'userbookingRequestServices': userbookingRequestServices
      });
      let nextJobStatus = '';
      each(userbookingRequestServices, (service) => {
        if (service.jobdetailstatusId != 7) {
          nextJobStatus = 'In Progress';
        }
      });
      if (!nextJobStatus) {
        nextJobStatus = 'Completed';
      }
      let updatedQuotesList = cloneDeep(this.props.requestDetails.quotesList);
      each(updatedQuotesList, (quote) => {
        if (quote.serviceId == serviceId) {
          quote.jobdetailstatusId = jobdetailstatusId;
        }
      });
      this.props.actions.updateJobStatus(this.props.requestDetails.userbookingrequestId, {
        "serviceids": [serviceId],
        "statusid": jobdetailstatusId,
        "nextJobStatus": nextJobStatus,
        "currentJobStatus": jobStatus,
        "updatedQuotesList": updatedQuotesList
      });
    }
  }
  checkStatusChangeArr () {
    let garageJobQuoteArr = this.state.garageJobQuoteArr;
    let statusArray = this.state.statusArray;
    let filteredStatusArr = [];
    statusArray.forEach(statusElement => {
      garageJobQuoteArr.forEach(garageElement => {
        if ((statusElement.serviceId === garageElement.serviceId) && garageElement.amount != 0) {
          statusElement.isPresent = true;
        }
      });
    });
    filteredStatusArr = statusArray.filter((element) => {
      return element.isPresent;
    })

    this.updateStatus(filteredStatusArr);
  }

  updateStatus(filteredStatusArr) {
    const jobStatus = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
    let nextJobStatus = '';
    let garageJobQuoteArr = cloneDeep(this.state.garageJobQuoteArr);
    let updatedQuotesList = [];
    let filteredArrLen = 0;
    let compArr = [];
    if (garageJobQuoteArr && garageJobQuoteArr.length) {
      garageJobQuoteArr.forEach((listElements) => {
        if (listElements.amount != 0) {
          listElements.shouldPresent = true;
        }
      })
    }
    updatedQuotesList = garageJobQuoteArr.filter((element) => {
      return element.shouldPresent;
    })
    if (updatedQuotesList && updatedQuotesList.length && filteredStatusArr && filteredStatusArr.length) {
      updatedQuotesList.forEach((updatedElement) => {
        filteredStatusArr.forEach((item) => {
          if (item.serviceId === updatedElement.serviceId) {
            updatedElement.jobdetailstatusId = item.jobdetailstatusId;
          }
        })
      })
      compArr = updatedQuotesList.map((item) => { return item.jobdetailstatusId }).filter((element) => {
        return element === 7;
      });
      if (updatedQuotesList.length === compArr.length) {
        nextJobStatus = 'Completed';
      }
      let updatedQuotesList = cloneDeep(this.props.requestDetails.garagejobquote.garagejobquotesdetail);
      each(updatedQuotesList, (quote) => {
        if (quote.serviceId == serviceId) {
          quote.jobdetailstatusId = jobdetailstatusId;
        }
      });
      this.props.actions.updateJobStatus(this.props.requestDetails.userbookingrequestId, {
        "serviceids": [serviceId],
        "statusid": jobdetailstatusId,
        "nextJobStatus": nextJobStatus,
        "currentJobStatus": jobStatus,
        "updatedQuotesList": updatedQuotesList
      });
    }
    if (filteredStatusArr && filteredStatusArr.length) {
      filteredStatusArr.forEach((item) => {
        setTimeout(() => {
          this.props.actions.updateJobStatus(this.props.requestDetails.userbookingrequestId, {
            "serviceid": item.serviceId,
            "statusid": item.jobdetailstatusId,
            "nextJobStatus": nextJobStatus,
            "currentJobStatus": jobStatus,
            "updatedQuotesList": updatedQuotesList
          });
        }, 1000);
      })
      this.setState({
        'userbookingRequestServices': userbookingRequestServices
      });
      let nextJobStatus = '';
      each(userbookingRequestServices, (service) => {
        if (service.jobdetailstatusId != 7) {
          nextJobStatus = 'In Progress';
        }
      });
      if (!nextJobStatus) {
        nextJobStatus = 'Completed';
      }
      let updatedQuotesList = cloneDeep(this.props.requestDetails.quotesList);
      each(updatedQuotesList, (quote) => {
        if (quote.serviceId == serviceId) {
          quote.jobdetailstatusId = jobdetailstatusId;
        }
      });
      this.props.actions.updateJobStatus(this.props.requestDetails.userbookingrequestId, {
        "serviceids": [serviceId],
        "statusid": jobdetailstatusId,
        "nextJobStatus": nextJobStatus,
        "currentJobStatus": jobStatus,
        "updatedQuotesList": updatedQuotesList
      });
    }
  }

  // serviceStatusOnChange () {
  //   const jobStatus = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
  //   if (this.state.garageJobQuoteArr && this.state.garageJobQuoteArr.length) {
  //     console.log("onStatusChange = garageJobQuoteArr ==", this.props.requestDetails.garagejobquote.garagejobquotesdetail);
  //     let garageJobQuoteArr = cloneDeep(this.state.garageJobQuoteArr);
  //     let statusArray = cloneDeep(this.state.statusArray);
  //     garageJobQuoteArr.forEach((item) => {
  //       statusArray.forEach((eachService) => {
  //         if(item.serviceId == eachService.serviceId) {
  //           item.jobdetailstatusId = eachService.jobdetailstatusId;
  //         }
  //       })
  //     });
  //     this.setState({
  //       'garageJobQuoteArr': garageJobQuoteArr
  //     });
  //     // console.log("id: = ", jobdetailstatusId, garageJobQuoteArr);
  //     let nextJobStatus = '';
  //     each(garageJobQuoteArr, (service) => {
  //       if (service.jobdetailstatusId != 7) {
  //         nextJobStatus = 'In Progress';
  //       }
  //     });
  //     if (!nextJobStatus) {
  //       nextJobStatus = 'Completed';
  //     }
  //     let updatedQuotesList = cloneDeep(this.props.requestDetails.garagejobquote.garagejobquotesdetail);
  //     each(updatedQuotesList, (quote) => {
  //       statusArray.forEach((eachService) => {
  //         if (quote.serviceId == eachService.serviceId) {
  //           quote.jobdetailstatusId = eachService.jobdetailstatusId;
  //         }
  //       })
  //     });
  //     updatedQuotesList.forEach((item) => {
  //       this.props.actions.updateJobStatus(this.props.requestDetails.userbookingrequestId, {
  //         "serviceid": item.serviceId,
  //         "statusid": item.jobdetailstatusId,
  //         "nextJobStatus": nextJobStatus,
  //         "currentJobStatus": jobStatus,
  //         "updatedQuotesList": updatedQuotesList
  //       });
  //     })
  //   }
  //   else {
  //     console.log("onStatusChange = garageJobQuoteArr = else ==", this.props.requestDetails.quotesList);
  //     let statusArray = cloneDeep(this.state.statusArray);
  //     let userbookingRequestServices = cloneDeep(this.state.userbookingRequestServices);
  //     statusArray.length && statusArray.forEach((eachService) => {
  //       userbookingRequestServices[eachService.serviceId].jobdetailstatusId = jobdetailstatusId;
  //     })
  //     this.setState({
  //       'userbookingRequestServices': userbookingRequestServices
  //     });
  //     let nextJobStatus = '';
  //     each(userbookingRequestServices, (service) => {
  //       if (service.jobdetailstatusId != 7) {
  //         nextJobStatus = 'In Progress';
  //       }
  //     });
  //     if (!nextJobStatus) {
  //       nextJobStatus = 'Completed';
  //     }
  //     let updatedQuotesList = cloneDeep(this.props.requestDetails.quotesList);
  //     each(updatedQuotesList, (quote) => {
  //       statusArray.forEach((eachService) => {
  //         if (quote.serviceId == eachService.serviceId) {
  //           quote.jobdetailstatusId = eachService.jobdetailstatusId;
  //         }
  //       })
  //     });
  //     updatedQuotesList.forEach((item) => {
  //       this.props.actions.updateJobStatus(this.props.requestDetails.userbookingrequestId, {
  //         "serviceid": item.serviceId,
  //         "statusid": item.jobdetailstatusId,
  //         "nextJobStatus": nextJobStatus,
  //         "currentJobStatus": jobStatus,
  //         "updatedQuotesList": updatedQuotesList
  //       });
  //     })
  //   }
  // }

  updatePayment() {
    this.setState({'isPaymentButtonLoading': true });

    this.props.actions.confirmPayment({
            'job_id': this.props.requestDetails.id,
            'request_id': this.props.requestDetails.userbookingrequestId,
          });


  }

  onChangeInspDesc(e) {
    this.setState({
        'inspectiondescription': e
    });
  }

  onInspecPriceChange(amount) {
    this.setState({
        'inspectionTotalAmount': amount
    });
  }

  getInspectionInfo(serviceId){
    return this.state.garageJobQuoteArr.find(x=> x.serviceId === serviceId);
  }

  checkInspection(serviceId,jobStatus){
    if(jobStatus === 'waiting' || jobStatus === 'applied'){
    let garageJobQuoteArr = cloneDeep(this.state.garageJobQuoteArr);
    let userbookingRequestServices = cloneDeep(this.state.userbookingRequestServices);

    garageJobQuoteArr.forEach((item)=>{
      if(item.serviceId === serviceId) {
        let status = (jobStatus === 'waiting') ? userbookingRequestServices[serviceId].status : item.status;
        let amount = (jobStatus === 'waiting') ? userbookingRequestServices[serviceId].amount : item.amount;
        item.isinspectionrequired = status ? !item.isinspectionrequired : false;
        if(!item.isinspectionrequired){
          userbookingRequestServices[serviceId].isValid= (amount>0 || (!status && !item.isinspectionrequire)) ? true :false;
          item.isValid = (amount > 0 || (!status && !item.isinspectionrequired)) ? true :false;
        } else {
          userbookingRequestServices[serviceId].isValid = true;
          item.isValid = true;
        }
      }
    });
    this.setState({
        'garageJobQuoteArr': garageJobQuoteArr,
        'userbookingRequestServices': userbookingRequestServices
    });
   }
  }

  showInspectionDesc(){
    this.setState({
        'showInspDescription': !this.state.showInspDescription
    });
  }

  checkStatusFlag(jobstatus){
    let status = false;
    if(jobStatus === 'closed' || jobStatus === 'decline' || jobStatus === 'completed' ||jobStatus === 'inprogress' || jobStatus === 'confirmed'){
      status = true;
    }
    return status;
  }

  onChangeToggleInsp(jobStatus){
    if(jobStatus === 'waiting' || jobStatus === 'applied'){
      this.setState({
        paidInspection: !this.state.paidInspection
      });
    }
  }

  createQuote(e, jobStatus, isEndDateTime, isQuoteNoteUpdated, inProgEditEnable) {

    const chassis_number = this.props.requestDetails.chassisNumber ? this.props.requestDetails.chassisNumber : (this.props.chassisNumber ? this.props.chassisNumber : '');

    let status = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
    if (e) {
      e.preventDefault();
    }
    this.errors['jobStartDate'] = !this.state.selectedStartDate;
    this.errors['jobStartTime'] = !this.state.selectedStartTime;
    this.errors['jobEndDate'] = !this.state.selectedEndDate;
    this.errors['jobEndTime'] = !this.state.selectedEndTime;
    let quoteInvalid = false;
    let quoteDescriptionInvalid = true;
    let services = [];
    let serviceIds = [];
    let notWaitingServicesArr = [];
    let notWaitingServicesArrEmptyErr = false;
    this.setState({
      emptyServicesErr: false,
      isServiceLoaded: false,
    });

    if (status != 'waiting') {

          let newAddservices = this.state.garageJobQuoteArr.filter((item) => {
            return item.status;
          });
        /*current Milage*/
        if(status == 'inprogress'){
          this.completeCarService();
        }

          newAddservices.forEach((item) => {

            if (item.isValid) {
              quoteInvalid = quoteInvalid ? true : false;
              item.isValid = true;
              notWaitingServicesArr.push({
                'service_id': item.serviceId,
                'description': item.description?item.description:'',
                'amount': Number(item.amount).toFixed(2),
               // 'isinspectionrequired': this.getInspectionInfo(item.serviceId).isinspectionrequired
              });
            }
            if ((item.amount == 0) || (!item.status)) {
              if(status == 'applied'){
               item.isValid = this.getInspectionInfo(item.serviceId).isinspectionrequired ? true : false;
               quoteInvalid = this.getInspectionInfo(item.serviceId).isinspectionrequired ? false : true;
              } else {
                item.isValid = false;
                quoteInvalid = true;
              }
            }
            if (item.isValidDescription == false) {
              quoteInvalid = true;

            }
          });
          if (newAddservices.length == 0) {
            notWaitingServicesArrEmptyErr = true;
            this.setState({
              emptyServicesErr: true
            });
          }

    }
    const userbookingRequestServices = cloneDeep(this.state.userbookingRequestServices);
    if (isEndDateTime) {
      each(userbookingRequestServices, (request) => {
        if (request.isValid && request.status && request.isValidDescription) {
          services.push({
            'service_id': request.serviceId,
            'description': request.description?request.description:'',
            'amount': Number(request.amount).toFixed(2),
            'isinspectionrequired': this.getInspectionInfo(request.serviceId).isinspectionrequired
          });
          serviceIds.push(request.serviceId);
        }
      });
      if (this.errors.jobEndDate || this.errors.jobEndTime || quoteInvalid || notWaitingServicesArrEmptyErr || checkDateTimeInvalid(1, this.state.selectedEndDate, this.state.selectedEndTime) || isGreaterThanStartDate(this.state.selectedEndDate, this.state.selectedEndTime, this.state.selectedStartDate, this.state.selectedStartTime)) {
        this.setState({ 'submissionError': true });
        this.errors.invalidEndTime = checkDateTimeInvalid(1, this.state.selectedEndDate, this.state.selectedEndTime);
      } else {
        let selectedStartTime = cloneDeep(this.state.selectedStartTime);
        let selectedEndTime = cloneDeep(this.state.selectedEndTime);
        selectedStartTime.set({ 'date': this.state.selectedStartDate.get('date'), 'month': this.state.selectedStartDate.get('month'), 'year': this.state.selectedStartDate.get('year') });
        selectedEndTime.set({ 'date': this.state.selectedEndDate.get('date'), 'month': this.state.selectedEndDate.get('month'), 'year': this.state.selectedEndDate.get('year') });

        this.setState({ 'submissionError': false});
        if (isQuoteNoteUpdated) {
          this.props.actions.createQuote({
            'userbookingrequestid': this.props.requestDetails.userbookingrequestId,
            'jobstartdatetime': selectedStartTime.utc().format(),
            'jobenddatetime': selectedEndTime.utc().format(),
            'services': status == 'waiting'? services : notWaitingServicesArr,
            'jobnotes': this.state.addJobeNote,
            'editmode': 1,
            'chassis_number': chassis_number,
            "inspectiondescription":this.state.inspectiondescription,
            "inspectionamount": Number(this.state.inspectionTotalAmount)
          }, jobStatus, false, true);
        }
        else {
          this.props.actions.createQuote({
            'userbookingrequestid': this.props.requestDetails.userbookingrequestId,
            'jobstartdatetime': selectedStartTime.utc().format(),
            'jobenddatetime': selectedEndTime.utc().format(),
            'services': status == 'waiting'? services : notWaitingServicesArr,
            'jobnotes': this.state.addJobeNote,
            'editmode': 1,
            'chassis_number': chassis_number,
            "inspectiondescription":this.state.inspectiondescription,
            "inspectionamount": Number(this.state.inspectionTotalAmount)
          }, jobStatus, true);
          this.checkStatusChangeArr();
        }
      }

    }
    else if (inProgEditEnable) {
      each(userbookingRequestServices, (request) => {
        if (request.isValid && request.status  && request.isValidDescription) {
          services.push({
            'service_id': request.serviceId,
            'description': request.description?request.description:'',
            'amount': Number(request.amount).toFixed(2),
            'isinspectionrequired': this.getInspectionInfo(request.serviceId).isinspectionrequired
          });
          serviceIds.push(request.serviceId);
        }
      });
      if (this.errors.jobEndDate || this.errors.jobEndTime || quoteInvalid || notWaitingServicesArrEmptyErr || checkDateTimeInvalid(1, this.state.selectedEndDate, this.state.selectedEndTime) || isGreaterThanStartDate(this.state.selectedEndDate, this.state.selectedEndTime, this.state.selectedStartDate, this.state.selectedStartTime)) {


        this.setState({ 'submissionError': true });
        this.errors.invalidEndTime = checkDateTimeInvalid(1, this.state.selectedEndDate, this.state.selectedEndTime);
      } else {


        let selectedStartTime = cloneDeep(this.state.selectedStartTime);
        let selectedEndTime = cloneDeep(this.state.selectedEndTime);
        selectedStartTime.set({ 'date': this.state.selectedStartDate.get('date'), 'month': this.state.selectedStartDate.get('month'), 'year': this.state.selectedStartDate.get('year') });
        selectedEndTime.set({ 'date': this.state.selectedEndDate.get('date'), 'month': this.state.selectedEndDate.get('month'), 'year': this.state.selectedEndDate.get('year') });


        this.setState({ 'submissionError': false, isDoneButtonLoading: true});
        this.props.actions.createQuote({
            'userbookingrequestid': this.props.requestDetails.userbookingrequestId,
            'jobstartdatetime': selectedStartTime.utc().format(),
            'jobenddatetime': selectedEndTime.utc().format(),
            'services': status == 'waiting'? services : notWaitingServicesArr,
            'jobnotes': this.state.addJobeNote,
            'editmode': 1,
            'chassis_number': chassis_number,
            "inspectiondescription":this.state.inspectiondescription,
            "inspectionamount": Number(this.state.inspectionTotalAmount)
        }, jobStatus);
        this.checkStatusChangeArr();
      }
    }
    else {

      if (status == 'waiting') {
        each(userbookingRequestServices, (request) => {
          if (request.isValid && request.status) {
            services.push({
              'service_id': request.serviceId,
              'description': request.description?request.description:'',
              'amount': Number(request.amount).toFixed(2),
              'isinspectionrequired': this.getInspectionInfo(request.serviceId).isinspectionrequired,
            });
            serviceIds.push(request.serviceId);
          }
          if (request.amount == 0 && request.status) {
            request.isValid = this.getInspectionInfo(request.serviceId).isinspectionrequired ? true : false;
            quoteInvalid = this.getInspectionInfo(request.serviceId).isinspectionrequired ? false : true;
          }

          if (!request.isValidDescription) {
            quoteInvalid = true;

          }

        });

      }


      if (this.errors.jobStartDate || this.errors.jobStartTime || this.errors.jobEndDate || this.errors.jobEndTime || quoteInvalid || notWaitingServicesArrEmptyErr || checkDateTimeInvalid(1, this.state.selectedStartDate, this.state.selectedStartTime) || checkDateTimeInvalid(1, this.state.selectedEndDate, this.state.selectedEndTime) || isGreaterThanStartDate(this.state.selectedEndDate, this.state.selectedEndTime, this.state.selectedStartDate, this.state.selectedStartTime)) {

        this.setState({ 'submissionError': true, userbookingRequestServices: userbookingRequestServices });
        this.errors.invalidStartTime = checkDateTimeInvalid(1, this.state.selectedStartDate, this.state.selectedStartTime);
        this.errors.invalidEndTime = checkDateTimeInvalid(1, this.state.selectedEndDate, this.state.selectedEndTime);
        if (!this.errors.invalidEndTime) {
          this.errors.invalidEndTime = isGreaterThanStartDate(this.state.selectedEndDate, this.state.selectedEndTime, this.state.selectedStartDate, this.state.selectedStartTime);
        }

      } else {
        let selectedStartTime = cloneDeep(this.state.selectedStartTime);
        let selectedEndTime = cloneDeep(this.state.selectedEndTime);
        selectedStartTime.set({ 'date': this.state.selectedStartDate.get('date'), 'month': this.state.selectedStartDate.get('month'), 'year': this.state.selectedStartDate.get('year') });
        selectedEndTime.set({ 'date': this.state.selectedEndDate.get('date'), 'month': this.state.selectedEndDate.get('month'), 'year': this.state.selectedEndDate.get('year') });
       this.setState({ 'submissionError': false, 'isButtonLoading': true });
       this.props.actions.createQuote({
          'userbookingrequestid': this.props.requestDetails.userbookingrequestId,
          'jobstartdatetime': selectedStartTime.utc().format(),
          'jobenddatetime': selectedEndTime.utc().format(),
          'services': status == 'waiting'? services : notWaitingServicesArr,
          'jobnotes': this.state.addJobeNote,
          'editmode': 1,
          'chassis_number': chassis_number,
          "inspectiondescription":this.state.inspectiondescription,
          "inspectionamount": Number(this.state.inspectionTotalAmount)
        }, jobStatus);
        this.checkStatusChangeArr();
      }
    }
  }

  applyPromoForUpdatedAmount(){

    let services = [];
    let serviceIds = [];
    let status = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();


    if (status == 'waiting') {
      const userbookingRequestServices = cloneDeep(this.state.userbookingRequestServices);


      each(userbookingRequestServices, (request) => {
        if (request.isValid && request.status) {
          services.push({
            'service_id': request.serviceId,
            'amount': Number(request.amount).toFixed(2),
            'description': request.description ? request.description : ''
          });
          serviceIds.push(request.serviceId);
        }
      });

    }else if (status != 'waiting') {
      const garageJobQuoteArr = cloneDeep(this.state.garageJobQuoteArr);


      each(garageJobQuoteArr, (request) => {
        if (request.isValid && request.status) {
          services.push({
            'service_id': request.serviceId,
            'amount': Number(request.amount).toFixed(2),
            'description': request.description ? request.description : ''
          });
          serviceIds.push(request.serviceId);
        }


      });

    }

    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    /* Make the Post Request Call to Manual Quote for a booking request with a offer */
    this.props.actions.applyPromotionalOffers({
      promo_code: this.props.requestDetails.offer.promoCode,
      services : serviceIds,
      quote_amount: sumByObject(services, 'amount'),
      garage_id: authData.garageId
    });


    this.setState({ isOfferApplied: true });

  }
  declineJob(currentJobStatus) {
    if (!this.state.showDeclineReasonErrTxt) {
      let jobStatus = this.props.requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
      window.localStorage.setItem("prevJobStatus", jobStatus);
      this.props.actions.declineAJob(this.props.requestDetails.userbookingrequestId, currentJobStatus, this.state.declineReason);
      this.setState({ showDeclineModal: false, declineJobLoading: true});
    }
  }


  render() {

    console.log('garage --->',this.state.garageJobQuote)

    const {
      requestDetails,
      actions,
      commonReducer
    } = this.props;
    const emptyNoteClass = this.state.addJobeNote ? 'add-quote-div': '';
    const jobStatus = requestDetails.jobStatus.replace(/\s+/, "").toLowerCase();
    const prevStatus = window.localStorage.getItem("prevJobStatus");


    let totalAmount = 0;
    let subTotalAmount = 0;
    let vatAmount = 0;
    if (jobStatus != 'waiting') {

      console.log("garageJobQuote",this.state.garageJobQuote)

      this.state.garageJobQuoteArr.forEach((item)=>{
        totalAmount = Number(totalAmount) + Number(parseFloat(item.amount > 0? item.amount : 0));
      });
    }
    else {
      totalAmount = sumByObject(this.state.userbookingRequestServices, 'amount');
    }

     subTotalAmount = this.state.discountAmount? totalAmount - this.state.discountAmount: totalAmount;

     vatAmount =  subTotalAmount ? Number(subTotalAmount) *( Number(this.state.vat)/100): 0;
    //
     totalAmount = subTotalAmount? Number(subTotalAmount)+Number(vatAmount) : 0;
    //



    const serviceJobDetailId =(requestDetails && requestDetails.serviceId == 2) ? this.state.garageJobQuoteArr && this.state.garageJobQuoteArr.length && this.state.garageJobQuoteArr[0].jobdetailstatusId : 0;
    const isCompleteCarService = requestDetails && (requestDetails.serviceId == 2) && (serviceJobDetailId == 3 || serviceJobDetailId == 7);
    // const isCompleteCarService = false;
    let quotesViewArr = [];
    if (jobStatus == 'waiting' || (prevStatus == 'waiting' && jobStatus == 'decline')) {
      quotesViewArr = map(this.state.quotesGrouped, (categories, key) => {
          let keyName = key;
          return (
            <div
              className="quotesSection-categories"
              key={key}
            >
              {(key.toLowerCase() != 'wash' && key.toLowerCase() != 'repair' && key.toLowerCase() != 'service') && <h5>
                {/*<i className="mdi mdi-delete" />*/}
                <span>{key}</span>
              </h5>}
              {map(categories, (category, categoryKey) => {
                return (jobStatus != 'waiting' && jobStatus != 'applied')
                  ?
                  (<div className="quotesSection-subcategories quotes-section-text quotesSection-subcategories-mobile row" key={categoryKey}>
                    <div className="col-md-7 col-sm-6 col-xs-9 pad0">
                      <label>
                        {/*<i className="mdi mdi-delete" />*/}
                        <span>{this.state.userbookingRequestServices[category.serviceId].name}</span>
                        { category.status &&
                          <div className="display-inline-arrow" onClick={(e) => {
                            this.showServiceDescp(e, category.serviceId, keyName);
                          }}><i className={category.showDescp ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'} /></div>
                        }
                      </label>
                    </div>
                    <div className="col-md-3 col-sm-4 col-xs-12 pad0">
                      {(jobStatus == 'confirmed' || jobStatus == 'inprogress') && <Select data={jobServiceStatuses} title="Status" isJobService={true} disabled={this.state.userbookingRequestServices[category.serviceId].jobdetailstatusId == 7} selectedId={this.state.userbookingRequestServices[category.serviceId].jobdetailstatusId} onChange={(id) => { this.onStatusChange(category.serviceId, id); }} />}
                    </div>
                    <div className="col-md-2 col-sm-2 pad0">
                    {
                      category.status ?
                      <div className="quotes-amount-card mobile-abs">
                        <TextInput

                          type="number"
                          name="price"
                          min="0"
                          disabled
                          value={Number(this.state.userbookingRequestServices[category.serviceId].amount).toFixed(2)}
                          onChange={(amount) => { this.onPriceChange(amount, category.serviceId); }} />
                        <span className="currency-tag">AED</span>
                      </div>
                      :
                      <span className="currency-tag">Unavailable</span>
                    }
                    </div>
                    <div className="col-md-12 pad0">
                      {!this.state.userbookingRequestServices[category.serviceId].isValid && category.status && <span className="error-text" style={{ color: 'red', float: 'right' }}>{"Invalid quote amount"}</span>}
                    </div>
                    { category.status && category.showDescp &&
                      <div className={jobStatus == 'inprogress' || jobStatus == 'confirmed' ? "service-descp-box-in-prog" : "service-descp-box"}>
                          {
                            (jobStatus === 'closed' || jobStatus === 'decline' || jobStatus === 'completed') ?
                              <div className>
                                <p>Description:</p>
                                <p>{this.state.userbookingRequestServices[category.serviceId].description ? this.state.userbookingRequestServices[category.serviceId].description : ' - '}</p>
                              </div>
                              :
                              <TextInput type="text"
                                label="Description"
                                name="description"
                                value={this.state.userbookingRequestServices[category.serviceId].description ? this.state.userbookingRequestServices[category.serviceId].description : ''}
                                onChange={(text) => {
                                  this.onServiceDescpChange(text, category.serviceId);
                                }}
                              />
                          }
                      </div>
                    }
                  </div>)
                  :
                  (<div className="quotesSection-subcategories row quotes-section-text" key={categoryKey}>
                    <div className="col-md-9 col-sm-6 col-xs-9 pad0">
                     {/*<label>
                        <span>{this.state.userbookingRequestServices[category.serviceId].name}</span>
                      </label>*/}
                     {(requestDetails.serviceType == 'Servicing') ?
                      <label>
                        <span>{this.state.userbookingRequestServices[category.serviceId].name}</span>
                        { category.status &&
                          <div className="display-inline-arrow" onClick={(e) => {
                            this.showServiceDescp(e, category.serviceId, keyName);
                          }}><i className={category.showDescp ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'} /></div>
                        }
                      </label>
                    :
                      <span className="checkbox-style checkbox-wrapper">
                        <input  type="checkbox" checked={category.status} id={this.state.userbookingRequestServices[category.serviceId].name} onChange={(checked) => {
                          this.handleCheck(category.serviceId, keyName);
                        }}/>
                        <label htmlFor={this.state.userbookingRequestServices[category.serviceId].name} className="custom-checkbox-2 custom-checkbox-subcat"></label>
                        <label htmlFor={this.state.userbookingRequestServices[category.serviceId].name} className="subcategory-name ">
                          <span>{this.state.userbookingRequestServices[category.serviceId].name}</span>
                        { category.status &&
                          <div className="display-inline-arrow" onClick={(e) => {
                            this.showServiceDescp(e, category.serviceId, keyName);
                          }}><i className={category.showDescp ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'} /></div>
                        }
                        </label>
                      </span>
                    }
                    </div>
                    {/*<div className="col-md-4 pad0">
                      {<Select data={statusType} title="Status" />}
                    </div>*/}
                    <div className="col-md-3 col-sm-6 col-xs-3 pad0">
                    {
                      category.status ?
                      <div className="quotes-amount-card">
                        <TextInput
                          type="number"
                          name="price"
                          min="0"
                          value={this.state.userbookingRequestServices[category.serviceId].amount}
                          onChange={(amount) => { this.onPriceChange(amount, category.serviceId); }} />
                        <span className="currency-tag">AED</span>
                      </div>
                      :
                      <span className="currency-tag">Unavailable</span>
                    }

                    </div>
                    <div className="col-md-12 pad0">
                      {!this.state.userbookingRequestServices[category.serviceId].isValid && category.status && <span className="error-text" style={{ color: 'red', float: 'right' }}>{"Invalid quote amount"}</span>}
                    </div>
                    { category.status && category.showDescp &&
                      <div className={jobStatus == 'inprogress' || jobStatus == 'confirmed' ? "service-descp-box-in-prog" : "service-descp-box"}>
                          {
                            (jobStatus === 'closed' || jobStatus === 'decline' || jobStatus === 'completed') ?
                              <div className>
                                <p>Description:</p>
                                <p>{this.state.userbookingRequestServices[category.serviceId].description ? this.state.userbookingRequestServices[category.serviceId].description : ' - '}</p>
                              </div>
                              :

                              <textarea name="description"
                                        maxLength="1005"

                                        onChange={(e) => {


                                          this.onServiceDescpChange(e.target.value , category.serviceId)



                                        }}


                                        value={this.state.userbookingRequestServices[category.serviceId].description ? this.state.userbookingRequestServices[category.serviceId].description : ''}
                              />
                          }
                        {!this.state.userbookingRequestServices[category.serviceId].isValidDescription && <span className="error-text" style={{ color: 'red', float: 'right' }}>{"Maximum 1000 characters are allowed"}</span>}

                      </div>
                    }
                    {/* (requestDetails.serviceType === 'Servicing' || requestDetails.serviceType === 'Repair') &&
                           <div className="inspection-main" className={requestDetails.serviceType === 'Servicing'?"inspection-service":""}>
                            <div className="col-md-9 col-sm-6 col-xs-12 pad0 mob-inspectionmainSpace">
                              <span className="checkbox-style checkbox-wrapper">
                                <span>
                                <input  type="checkbox" checked={category.isinspectionrequired} id={`inspection-${category.serviceId}`} onClick={() => this.checkInspection(category.serviceId,jobStatus)}/>
                                <label htmlFor={`inspection-${category.serviceId}`} className="custom-checkbox-2 custom-checkbox-subcat"></label>
                                </span>
                                <label htmlFor="inspection" className="subcategory-name ">
                                  <span>Inspection Required</span>
                                </label>
                              </span>
                            </div>
                  </div>*/}

                      </div>
                    );
                })}
            {(jobStatus != 'decline' &&  jobStatus != 'confirmed' && jobStatus != 'inprogress' && jobStatus != 'accepted' && jobStatus != 'completed' && jobStatus != 'expired' && jobStatus != 'closed') && (requestDetails.serviceType != 'Servicing') && <a className="add-category" onClick={()=>{this.openCategoryModal(key, categories, requestDetails.serviceType)}}>Add Sub Category</a>}
            </div>
          );
      });
    }
    else {
      let qArr = this.state.garageJobQuoteArr;
      let result = qArr.reduce((h, a) => Object.assign(h, { [a.parent.name]:( h[a.parent.name] || [] ).concat(a) }), {});
      let gropuQArr = [];
      Object.keys(result).map((key)=>{
        let obj = {};
        obj = {
          groupName: key,
          value: result[key]
        };
        gropuQArr.push(obj);
      });
      quotesViewArr = map(gropuQArr, (categories, key) => {
            let keyName = categories.groupName;
            return (
              <div className="quotesSection-categories" key={categories.groupName}>
                {(categories.groupName.toLowerCase() != 'wash' && categories.groupName.toLowerCase() != 'repair' && categories.groupName.toLowerCase() != 'service') && <h5>
                  {/*<i className="mdi mdi-delete" />*/}
                  <span>{categories.groupName}</span>
                </h5>}
                {map(categories.value, (category, categoryKey) => {
                  return (jobStatus != 'waiting' && jobStatus != 'applied' && !this.state.inProgEditEnable && category.status)
                    ?
                    (
                      <div className="quotesSection-subcategories quotes-section-text quotesSection-subcategories-mobile row" key={category.name}>
                      <div className="col-md-6 col-sm-6 col-xs-9 pad0">
                        <label>
                          <span>{category.name}</span>
                          {
                            category.status &&
                            <div className="display-inline-arrow" onClick={(e) => {
                              this.showServiceDescp(e, category.serviceId, keyName, categories.value);
                            }}><i className={category.showDescp ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'} /></div>
                          }
                        </label>
                      </div>
                      <div className="col-md-4 col-sm-4 col-xs-12 pad0">
                        {(jobStatus == 'confirmed' || jobStatus == 'inprogress') && <Select data={jobServiceStatuses} title="Status" isJobService={true} disabled={category.jobdetailstatusId == 7} selectedId={category.jobdetailstatusId} onChange={(id) => { this.onStatusChange(category.serviceId, id); }} />}
                      </div>
                      <div className="col-md-2 col-sm-2 pad0">
                      {
                        category.status ?
                        <div className="quotes-amount-card mobile-abs">
                          <TextInput
                            type="number"
                            name="price"
                            disabled
                            min="0"
                            value={Number(category.amount).toFixed(2)}
                            onChange={(amount) => { this.onPriceChange(amount, category.serviceId); }} />
                          <span className="currency-tag">AED</span>
                        </div>
                        :
                        <span className="currency-tag">Unavailable</span>
                      }
                      </div>
                      <div className="col-md-12 pad0">
                        {!category.isValid && <span className="error-text" style={{ color: 'red', float: 'right' }}>{"Invalid quote amount"}</span>}
                      </div>
                      {
                        category.status && category.showDescp &&
                        <div className={jobStatus == 'inprogress' || jobStatus == 'confirmed' ? "service-descp-box-in-prog" : "service-descp-box"}>
                          {
                            (jobStatus === 'closed' || jobStatus === 'decline' || jobStatus === 'completed') ?

                            <div className="">
                              <p>Description:</p>
                              <p>{category.description ? category.description : ' - '}</p>
                            </div>

                            :
                              <textarea name="description"
                                        maxLength="1005"
                                        onChange={e => this.onServiceDescpChange(e.target.value , category.serviceId)}
                                        value={category.description ? category.description : ''}
                              />

                          }
                        </div>
                      }
                      </div>
                    )
                    :
                    (
                      (jobStatus == 'applied' || this.state.inProgEditEnable) &&
                      <div className="quotesSection-subcategories row quotes-section-text" key={categoryKey}>
                        <div className="col-md-5 col-sm-6 col-xs-12 pad0">
                        {/*<div className={(category.jobdetailstatusId == 6) ? "col-md-7 col-sm-6 col-xs-12 pad0" : "col-md-5 col-sm-6 col-xs-12 pad0"}>*/}
                         {/*<label>
                            <span>{this.state.userbookingRequestServices[category.serviceId].name}</span>
                          </label>*/}
                         {
                            ((requestDetails.serviceType == 'Servicing') || (category.jobdetailstatusId == 7 || category.jobdetailstatusId == 3) || (jobStatus === 'completed')) ?
                          <label>
                              <span>{category.name}</span>
                            {
                              category.status &&
                              <div className="display-inline-arrow" onClick={(e) => {
                                this.showServiceDescp(e, category.serviceId, keyName, categories.value);
                              }}><i className={category.showDescp ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'} /></div>
                            }
                          </label>
                        :
                          <span className="checkbox-style checkbox-wrapper">
                            <input  type="checkbox" checked={category.status} id={category.name} onChange={(checked) => {
                              this.handleCheck(category.serviceId, keyName, categories.value);
                            }}/>
                            <label htmlFor={category.name} className="custom-checkbox-2 custom-checkbox-subcat"></label>
                            <label htmlFor={category.name} className="subcategory-name ">
                              <span>{category.name}</span>
                            {
                              category.status &&
                              <div className="display-inline-arrow" onClick={(e) => {
                                this.showServiceDescp(e, category.serviceId, keyName, categories.value);
                              }}><i className={category.showDescp ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'} /></div>
                            }
                            </label>
                          </span>
                        }
                        </div>
                        <div className="col-md-4 col-sm-4 col-xs-12 pad0 padb10">
                        {/*<div className={(category.jobdetailstatusId == 6) ? "col-md-3 col-sm-4 col-xs-12 pad0 padb10" : "col-md-4 col-sm-4 col-xs-12 pad0 padb10"}>*/}
                          {(jobStatus == 'confirmed' || jobStatus == 'inprogress') && <Select data={jobServiceStatuses} title="Status" isJobService={true} disabled={(category.jobdetailstatusId == 7) || !category.status} selectedId={category.jobdetailstatusId} onChange={(id) => { this.onStatusChange(category.serviceId, id); }} />}
                        </div>
                        <div className="col-md-3 col-sm-6 col-xs-12 pad0">
                        {/*<div className={(category.jobdetailstatusId == 6) ? "col-md-2 col-sm-6 col-xs-12 pad0" : "col-md-2 col-sm-6 col-xs-12 pad0"}>*/}
                        {
                            category.status ?
                          <div className="quotes-amount-card">
                            <TextInput
                              type="number"
                              name="price"
                              min="0"
                              value={(category.jobdetailstatusId == 7 || category.jobdetailstatusId == 3) ? Number(category.amount).toFixed(2):category.amount}
                              disabled={(category.jobdetailstatusId == 7 || category.jobdetailstatusId == 3)}
                              onChange={(amount) => { this.onPriceChange(amount, category.serviceId); }} />
                            <span className="currency-tag">AED</span>
                          </div>
                          :
                          <span className="currency-tag">Unavailable</span>
                        }
                        </div>
                        <div className="col-md-12 pad0">
                         {!category.isValid && <span className="error-text" style={{ color: 'red', float: 'right' }}>{"Invalid quote amount"}</span>}
                        </div>
                        {
                          category.status && category.showDescp &&
                          <div className={jobStatus == 'inprogress' || jobStatus == 'confirmed' ? "service-descp-box-in-prog" : "service-descp-box"}>
                          {
                            (jobStatus === 'closed' || jobStatus === 'decline' || jobStatus === 'completed') ?

                            <div className="">
                              <p>Description:</p>
                              <p>{category.description ? category.description : ' - '}</p>
                            </div>

                            :

                                <textarea name="description"
                                          maxLength="1005"
                                          onChange={e => this.onServiceDescpChange(e.target.value , category.serviceId)}
                                          value={category.description ? category.description : ''}
                                />

                          }
                          </div>
                        }
                        {(isCompleteCarService && requestDetails.serviceType === 'Servicing') &&<div>
                        <div className="col-md-5 col-sm-12 col-xs-12 pad0"/>
                        <div className={this.state.currentMileageError ? "col-md-7 col-sm-12 col-xs-12 pad0 form-group quotes-amount-card error quotes-current-milleage": "col-md-7 col-sm-12 col-xs-12 pad0 form-group quotes-amount-card quotes-current-milleage"}>
                          <TextInput
                              type="number"
                              label="Current Mileage"
                              name="currentMileage"
                              min="0"
                              value={this.state.currentMileage}
                              onChange={(currentMileage) => { this.setState({'currentMileage': currentMileage});}} />
                          {this.state.currentMileageError && <span className="error-text">Provide current mileage to complete the job</span>}
                        </div>
                      </div>}
                        {/* (requestDetails.serviceType === 'Servicing' || requestDetails.serviceType === 'Repair') &&
                           <div className="inspection-main" className={requestDetails.serviceType === 'Servicing'?"inspection-service":""}>
                            <div className="col-md-9 col-sm-6 col-xs-12 pad0 mob-inspectionmainSpace">
                              <span className="checkbox-style checkbox-wrapper">

                                <span>
                                <input  type="checkbox" checked={category.isinspectionrequired} id={`inspection-${category.serviceId}`} onClick={() => this.checkInspection(category.serviceId,jobStatus)}/>
                                <label htmlFor={`inspection-${category.serviceId}`} className="custom-checkbox-2 custom-checkbox-subcat"></label>
                                </span>
                                <label htmlFor="inspection" className="subcategory-name ">
                                  <span>Inspection Required</span>
                                </label>
                              </span>
                            </div>
                      </div>*/}
                      </div>
                    );
                })}
              {(jobStatus != 'decline' && jobStatus != 'accepted' && jobStatus != 'completed' && jobStatus != 'expired' && jobStatus != 'closed' && this.state.inProgEditEnable) && (requestDetails.serviceType != 'Servicing') && <a className="add-category" onClick={()=>{this.openCategoryModal(categories.groupName, categories.value, requestDetails.serviceType)}}>Add Sub Category</a>}
              {/*this.state.inProgEditEnable &&  <a className="add-category" onClick={()=>{this.openCategoryModal(categories.groupName, categories.value, requestDetails.serviceType)}}>Add Sub Category</a>*/}
              </div>
            );
      });
    }
    const quotesView = quotesViewArr;
    return (
      <div>
        <div className="quotesSection-view">
        <CustomScroll
            heightRelativeToParent="calc(100%)"
            allowOuterScroll={true}
          >
          <div className="quotesSection-dateTime quotes-dateTime-holder row">
            <h5>Job Start</h5>
            <div className="col-md-6 padLeft0 form-group error col-xs-6 dt-width-50">
              <DatePicker
                dateFormat="MMMM D, YYYY"
                disabled={jobStatus != 'waiting' && jobStatus != 'applied'}
                selected={this.state.selectedStartDate}
                onChange={(date) => { this.setState({ selectedStartDate: date }); this.errors.jobStartDate = false; this.errors.invalidStartTime = checkDateTimeInvalid(1, date, this.state.selectedStartTime); }}
                minDate={moment().add(1, 'hours')}
                placeholderText="Date" />
              {this.errors.jobStartDate && <span className="error-text">Please select job start date</span>}
            </div>
            <div className="col-md-6 padRight0 form-group error col-xs-6 dt-width-50">
              <TimePicker
                disabled={jobStatus != 'waiting' && jobStatus != 'applied'}
                showSecond={false}
                className="custom-timepicker"
                format={'h:mm a'}
                onChange={(time) => { this.setState({ selectedStartTime: time }); this.errors.jobStartTime = false; this.errors.invalidStartTime = checkDateTimeInvalid(1, this.state.selectedStartDate, time); }}
                value={this.state.selectedStartTime}
                use12Hours
                placeholder="Time"
              />
              {(this.errors.jobStartTime || this.errors.invalidStartTime) && <span className="error-text">{this.errors.invalidStartTime ? 'Must be 1 hr greater than current time' : 'Please select job start time'}</span>}
            </div>
          </div>
          <div className="quotesSection-dateTime quotes-dateTime-holder row">
            <h5>Job End</h5>
            <div className="col-md-6 padLeft0 form-group error col-xs-6 dt-width-50">
              <DatePicker
                dateFormat="MMMM D, YYYY"
                disabled={!(jobStatus == 'waiting' || jobStatus == 'applied' || jobStatus == 'confirmed' || jobStatus == 'inprogress')}
                selected={this.state.selectedEndDate}
                onChange={(date) => { this.errors.jobEndDate = false; this.errors.invalidEndTime = checkDateTimeInvalid(1, date, this.state.selectedEndTime); this.setState({ selectedEndDate: date });}}
                minDate={moment().add(1, 'hours')}
                placeholderText="Date" />
              {this.errors.jobEndDate && <span className="error-text">Please select job end date</span>}
            </div>
            <div className="col-md-6 padRight0 form-group error col-xs-6 dt-width-50">
              <TimePicker
                disabled={!(jobStatus == 'waiting' || jobStatus == 'applied' || jobStatus == 'confirmed' || jobStatus == 'inprogress')}
                showSecond={false}
                className="custom-timepicker"
                format={'h:mm a'}
                onChange={(time) => { this.errors.jobEndTime = false; this.errors.invalidEndTime = checkDateTimeInvalid(1, this.state.selectedEndDate, time); if (!this.errors.invalidEndTime) {this.errors.invalidEndTime = isGreaterThanStartDate(this.state.selectedEndDate, time, this.state.selectedStartDate, this.state.selectedStartTime);} this.setState({ selectedEndTime: time });}}
                value={this.state.selectedEndTime}
                use12Hours
                placeholder="Time"
              />
              {(this.errors.jobEndTime || this.errors.invalidEndTime) && <span className="error-text">{this.errors.invalidEndTime ? 'Must be 1 hr greater than job start time and current time' : 'Please select job end time'}</span>}
              {/* {jobStatus != 'waiting' && jobStatus != 'applied' && jobStatus != 'decline' && jobStatus != 'completed' && jobStatus != 'closed' && <Button style={{marginTop: "30px", marginBottom: "30px", marginLeft:"-20px", padding: ".2em .6em .3em"}} btnSize="sm" fontSize={13} label="Update End Date & Time" btnCallBack={(e) => { this.createQuote(e, jobStatus, true);}} btnType="label" isButtonLoading={this.state.isButtonLoading} backgroundColor="transparent" customClass="auto-width update-end-time-btn"/>} */}
            </div>
          </div>
          <div className="quotesSection-content row">
            <div className="quotesSection-block-head row">
              {/* <div className="col-md-6 pad0">
                  <h5>Car {requestDetails.serviceType}</h5>
                </div> */}
              <div className="quotesSection-content row">
                <div className="quotesSection-block-head row">
                  <div className="col-md-6 col-sm-6 col-xs-4 pad0">
                    <h5>Car {requestDetails.serviceType}</h5>
                  </div>
                  {<div className="col-md-4 col-sm-4 col-xs-4 pad0">
                    {(jobStatus == 'confirmed' || jobStatus == 'inprogress') && <h5>Status</h5>}
                  </div>}
                  <div className="col-md-2 col-sm-2 col-xs-4 pad0">
                    <h5 className="pull-right">Amount</h5>
                  </div>
                </div>
              </div>
            </div>
            <div className={(jobStatus == 'inprogress'? "categoriesScroll-wrapper categoriesScroll-inprogress-wrapper mhide" : "categoriesScroll-wrapper mhide")}>

                <div className="categories-block">
                  {this.state.sectionLoader ? <PageLoader /> : quotesView}
                  {
                    (jobStatus == 'inprogress' || jobStatus == 'confirmed') && !this.state.inProgEditEnable && (requestDetails.serviceType != 'Servicing') &&

                    <div className="col-sm-12 pad0 text-right m-10-0">
                      <Button style={{marginTop: "10px", marginBottom: "10px", padding: "10px"}}
                        btnSize="sm" fontSize={13} label="Edit"
                        btnCallBack={(e) => {this.updateInProgQuotes();}}
                        btnType="label"
                        backgroundColor="transparent"
                      />
                    </div>
                  }
                  {/*
                    (jobStatus == 'inprogress' || jobStatus == 'confirmed') && this.state.inProgEditEnable && (requestDetails.serviceType != 'Servicing') &&

                    <div className="col-sm-12 pad0 text-right m-10-0">
                      <Button style={{marginTop: "10px", marginBottom: "10px", padding: "10px"}}
                        btnSize="sm" fontSize={13} label="Done"
                        btnCallBack={(e) => {
                          this.doneInProgQuotesUpdate(e, jobStatus);

                        }}
                        btnType="quote"
                        isButtonLoading={this.state.isDoneButtonLoading}
                        backgroundColor="#ED3124"
                      />
                    </div>
                  */}

                </div>

                <div>
                { /*(requestDetails.serviceType === 'Servicing' || requestDetails.serviceType === 'Repair') &&
                           <div className="inspection-main inspection-total-main">
                              <div className="col-md-9 col-sm-6 col-xs-12 pad0 mob-inspectionmainSpace">
                               <span className="checkbox-style checkbox-wrapper">

                      <label htmlFor="Inspection" className="subcategory-name">
                        <span className="total-inspection">Inspection Required</span>
                        <div className="display-inline-arrow" onClick={(e) =>{e.preventDefault(); this.showInspectionDesc()} }>
                           <i className={this.state.showInspDescription ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'} />
                        </div>
                      </label>

                      <span className="inspection-payment ">  Free
                         <ToggleSwitch
                           className="inspe-toggleSwitch"
                           checked={this.state.paidInspection }
                           onChange={() => {
                             this.onChangeToggleInsp(jobStatus);
                           }}
                           size="small"
                           ref={(node) => {
                             this.toggleSwitch = node;
                           }} />
                           Paid
                      </span>
                  </span>
                </div>
                {  this.state.paidInspection &&
                <div className="col-md-3 col-sm-5 col-xs-12 pad0 mob-inspectionSpace">
                  <div className="quotes-amount-card">
                    <TextInput
                      type="number"
                      name="price"
                      min="0"
                      disabled={(jobStatus != 'waiting' && jobStatus != 'applied')}
                      value={this.state.inspectionTotalAmount}
                      onChange={(amount) => { this.onInspecPriceChange(amount); }} />
                    <span className="currency-tag">AED</span>
                  </div>
                </div>}
                {(this.state.inspectionTotalAmount === 0 && this.state.paidInspection) && <span className="error-inspection-text">Inspection amount Required</span>}
                { this.state.showInspDescription &&
                  <div className="service-descp-box insp-desc">
                      {
                        (jobStatus !== 'waiting' && jobStatus !== 'applied') ?
                          <div className="insp-description-text">
                            Description :{this.state.inspectiondescription}
                          </div>
                          :
                          <TextInput type="text"
                            label="Description"
                            name="description"
                            value={this.state.inspectiondescription}
                            onChange={(e) => {
                              this.onChangeInspDesc(e);
                            }}
                          />
                      }
                  </div>
                }
                </div>
              */ }



                </div>
                {requestDetails && requestDetails.offer && (requestDetails.offer.promoCode) && <div style={{
                  padding: "15px"
                }}>

                  <div className="promo-offer-block">
                    <div>
                      Promo Code <span className="promo-offer-code">'{requestDetails.offer.promoCode}'</span>

                      {jobStatus == 'waiting' || jobStatus == 'applied' ?
                        <a className="promo-offer-code-apply" onClick={(e) => {
                          this.applyPromoForUpdatedAmount()
                        }}
                        >Apply</a>
                      : ""}
                      {/*<label> {offerDiscount? "-" : "" } {offerDiscount}  {garageQuotesPricingDetails && garageQuotesPricingDetails.currency}</label>*/}
                    </div>
                    <span className="error-text error" >{this.state.promotionalOffersMessage}</span>

                  </div>


                  {requestDetails.offer && requestDetails.offer.discountPercentage?
                    <div className="promo-offer-block-percent">
                      <div>
                        <span className="promo-offer-code"> {requestDetails.offer.discountPercentage}% off</span>
                        <span className="promo-offer-code-right"> {this.state.discountAmount? "-"+this.state.discountAmount.toFixed(2): requestDetails.offer && requestDetails.offer.discountedAmount ? "-"+requestDetails.offer.discountedAmount.toFixed(2): "0.00"} {requestDetails.currency } </span>

                      </div>
                    </div>
                    :
                      <div className="promo-offer-block-percent">
                        <div>

                          <span className="promo-offer-code"> {requestDetails.offer.discountAmount} {requestDetails.currency} off</span>
                          <span className="promo-offer-code-right"> {this.state.discountAmount? "-"+this.state.discountAmount.toFixed(2) :requestDetails.offer && requestDetails.offer.discountedAmount ? "-"+requestDetails.offer.discountedAmount.toFixed(2) : "0.00"} {requestDetails.currency }  </span>
                        </div>
                      </div>

                  }
                </div>}
                {
                  this.state.emptyServicesErr && <span className="error-text empty-service">Services can't be qmpty</span>
                }


              {jobStatus == 'waiting' || jobStatus == 'applied' || jobStatus == 'confirmed'|| jobStatus == 'inprogress' ?
                <div className="quotesSection-total 1">
                  {this.state.vat ?
                    <div className="details">
                      <label>Sub Total</label>
                      <span>

                      {this.state.garageJobQuote ? Number(subTotalAmount).toFixed(2) : ""} {this.state.garageJobQuote && this.state.garageJobQuote.currency ? this.state.garageJobQuote.currency : "AED"}

                                                </span>
                    </div>
                    : ""}
                  {this.state.vat ?
                    <div className="details">
                      <label>VAT ({this.state.vat} %)</label>
                      <span>
                      { vatAmount.toFixed(2) } {this.state.garageJobQuote && this.state.garageJobQuote.currency ? this.state.garageJobQuote.currency : "AED"}
                                                </span>
                    </div>
                    : ''
                  }
                  <div className="total">
                    <label>Total</label>
                    <span>
                      {totalAmount.toFixed(2)} {this.state.garageJobQuote && this.state.garageJobQuote.currency ? this.state.garageJobQuote.currency : "AED"}
                                                </span>
                  </div>
                  {!this.state.vat &&

                  <div><label className="vat-details">All prices include VAT.</label></div>
                  }
                  <div>
                  </div>
                </div>


                :
                <div className="quotesSection-total 2">
                  {this.state.vat ?
                    <div className="details">
                      <label>Sub Total</label>
                      <span>

                      {this.state.garageJobQuote ? (Number(this.state.garageJobQuote.totalamount) - Number(this.state.garageJobQuote.discountAmount)).toFixed(2) : ""} {this.state.garageJobQuote && this.state.garageJobQuote.currency ? this.state.garageJobQuote.currency : "AED"}

                                                </span>
                    </div>
                    : ""}
                  {this.state.vat ?
                    <div className="details">
                      <label>VAT ({this.state.vat} %)</label>
                      <span>
                      {(this.state.garageJobQuote && this.state.garageJobQuote.garage && this.state.garageJobQuote.garage.garage_taxes.length) ? (this.state.garageJobQuote.garage.garage_taxes[0].value).toFixed(2) : ""} {this.state.garageJobQuote && this.state.garageJobQuote.currency ? this.state.garageJobQuote.currency : "AED"}
                                                </span>
                    </div>
                    : ''
                  }
                    <div className="total">
                      <label>Total</label>
                      <span>
                      {this.state.garageJobQuote && this.state.garageJobQuote.finalAmount ? (this.state.garageJobQuote.finalAmount).toFixed(2) : ""} {this.state.garageJobQuote && this.state.garageJobQuote.currency ? this.state.garageJobQuote.currency : "AED"}
                                                </span>
                    </div>

                  {this.state.garageJobQuote && this.state.garageJobQuote.garage && !this.state.garageJobQuote.garage.garage_taxes &&

                  <div><label className="vat-details">All prices include VAT.</label></div>
                  }
                  <div>
                  </div>
                </div>

              }
              {
                (jobStatus == 'completed' && requestDetails.paymentstatus.method == "Pay at Shop"&& requestDetails.paymentstatus.displayname == "Pending" ) &&
                  <div className="payment-container payment-container-detail">
                    <div className="payment-status">
                      <div className="desc-block">
                        <h5 className="title">Payment Mode</h5>

                        <div>
                          <h5 className="payment-mode">Pay at Shop</h5>
                          <span className="payment-type pull-right">
                         <ToggleSwitch
                           checked={this.state.payAtShopSwitch}
                           onChange={() => {
                             this.setState({ payAtShopSwitch: !this.state.payAtShopSwitch });
                           }}
                           size="small"
                           ref={(node) => {
                             this.toggleSwitch = node;
                           }} />
                        </span>
                        </div>

                      </div>

                    </div>
                  </div>

              }
                {jobStatus != 'waiting' && jobStatus != 'applied' ?
                  (jobStatus === 'closed' || jobStatus === 'decline' || jobStatus === 'completed') ?
                    <div className="note-holder">
                      <p>Note:</p>
                      <p>{this.state.addJobeNote ? this.state.addJobeNote  : ' - '}</p>
                    </div>
                    :
                    <div className="note-holder">
                        <TextInput type="text"
                          label="Add Notes"
                          name="name"
                          value={this.state.addJobeNote}
                          onChange={(text) => { this.onQuoteChange(text); }}
                          // onBlur={() => { this.createQuote(null, jobStatus, true, true); }}
                        />
                    </div>
                  :
                  <div className="note-holder">
                      <TextInput type="text"
                        label="Add Notes"
                        name="name"
                        value={this.state.addJobeNote}
                        onChange={(text) => { this.onQuoteChange(text); }}
                      />
                  </div>
                }

              {this.state.adminRemarks?
              <div className="note-holder">
                <h5>Carcility updates:</h5>
                <p>{ this.state.adminRemarks }</p>
              </div>
                : "" }
                <div className="quotesSection-button">
                  {
                    (jobStatus == 'waiting' || jobStatus == 'applied' || jobStatus == 'confirmed') &&
                    <Button
                      btnSize="sm"
                      btnType="label"
                      fontSize={13}
                      label="Decline Job"
                      backgroundColor="transparent"
                      btnCallBack={
                        (e) => {
                          e.preventDefault();
                          this.setState({ showDeclineModal: true})
                        }
                      }
                    />
                  }
                  {
                    (jobStatus == 'completed' && requestDetails.paymentstatus.method == "Pay at Shop"&& requestDetails.paymentstatus.displayname == "Pending" && this.state.payAtShopSwitch ) &&
                    <Button
                      btnSize="sm"
                      btnType="quote"
                      fontSize={13}
                      label="Update Quote"
                      backgroundColor="#ED3124"
                      isButtonLoading={
                        this.state.isPaymentButtonLoading
                      }
                      btnCallBack={
                        (e) => {
                          e.preventDefault();
                          this.updatePayment(e, jobStatus, true);
                        }
                      }
                    />
                  }
                  {
                    (jobStatus == 'applied' || jobStatus == 'waiting') &&
                    !(_.isEmpty(this.state.userbookingRequestServices)) &&
                    <Button
                      btnSize="sm"
                      fontSize={13}
                      disabled={totalAmount > 0 ?  false : this.state.promotionalOffersIsApproved ? false : true}
                      label={
                        jobStatus == 'confirmed' ? 'Update Job End' : jobStatus == 'waiting' ? "Send Quote" : "Update Quote"
                      }
                      btnCallBack={
                        (e) => {
                          if (jobStatus == 'confirmed') {
                            this.createQuote(e, jobStatus, true);
                          } else {
                            this.createQuote(e, jobStatus);
                            }
                            const {vehicleData} = this.props.requestDetails;
                            //this.props.actions.editCarProfile(vehicleData, true, )
                          }
                      }
                      btnType="quote"
                      isButtonLoading={
                        this.state.isButtonLoading
                      }
                      backgroundColor="#ED3124"
                    />
                  }
                  {
                    (jobStatus == 'inprogress' || jobStatus == 'confirmed') &&
                    <Button btnSize="sm" fontSize={13}
                      btnSize="sm" fontSize={13} label="Update Quote"
                      btnCallBack={(e) => {
                        this.doneInProgQuotesUpdate(e, jobStatus);

                      }}
                      btnType="quote"
                      isButtonLoading={this.state.isDoneButtonLoading}
                      backgroundColor="#ED3124"
                    />
                  }
                  {(isCompleteCarService && jobStatus == 'completed') && <Button btnSize="sm" fontSize={13} label="Update Mileage" btnCallBack={this.completeCarService.bind(this)} btnType="quote" isButtonLoading={this.state.isButtonLoading} backgroundColor="#ED3124" />}
                </div>
            </div>
            <div className="mshow mobile-scroll-view">
              <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true}>
              <div className="categories-block">
                {this.state.sectionLoader ? <PageLoader /> : quotesView}
                {
                    (jobStatus == 'inprogress' || jobStatus == 'confirmed') && !this.state.inProgEditEnable && (requestDetails.serviceType != 'Servicing') &&

                    <div className="col-sm-12 pad0 text-right m-10-0">
                      <Button style={{marginTop: "10px", marginBottom: "10px", padding: "10px"}}
                        btnSize="sm" fontSize={13} label="Edit"
                        btnCallBack={(e) => {this.updateInProgQuotes();}}
                        btnType="label"
                        backgroundColor="transparent"
                      />
                    </div>
                  }
                  {/*
                    (jobStatus == 'inprogress' || jobStatus == 'confirmed') && this.state.inProgEditEnable && (requestDetails.serviceType != 'Servicing') &&

                    <div className="col-sm-12 pad0 text-right m-10-0">
                      <Button style={{marginTop: "10px", marginBottom: "10px", padding: "10px"}}
                        btnSize="sm" fontSize={13} label="Done"
                        btnCallBack={(e) => {
                          this.doneInProgQuotesUpdate(e, jobStatus);

                        }}
                        btnType="quote"
                        isButtonLoading={this.state.isDoneButtonLoading}
                        backgroundColor="#ED3124"
                      />
                    </div>
                  */}
              </div>

                {jobStatus == 'waiting' || jobStatus == 'applied' || jobStatus == 'confirmed'|| jobStatus == 'inprogress' ?
                  <div className="quotesSection-total 3">
                    {this.state.vat ?
                      <div className="details">
                        <label>Sub Total</label>
                        <span>

                      {this.state.garageJobQuote ? Number(subTotalAmount).toFixed(2) : ""} {this.state.garageJobQuote && this.state.garageJobQuote.currency ? this.state.garageJobQuote.currency : "AED"}

                                                </span>
                      </div>
                      : ""}
                    {this.state.vat ?
                      <div className="details">
                        <label>VAT ({this.state.vat} %)</label>
                        <span>
                      { vatAmount.toFixed(2) } {this.state.garageJobQuote && this.state.garageJobQuote.currency ? this.state.garageJobQuote.currency : "AED"}
                                                </span>
                      </div>
                      : ''
                    }
                    <div className="total">
                      <label>Total</label>
                      <span>
                      {totalAmount ? totalAmount.toFixed(2) : ""} {this.state.garageJobQuote && this.state.garageJobQuote.currency ? this.state.garageJobQuote.currency : "AED"}
                                                </span>
                    </div>
                    {!this.state.vat &&

                    <div><label className="vat-details">All prices include VAT.</label></div>
                    }
                    <div>
                    </div>
                  </div>


                  :
                  <div className="quotesSection-total 4">
                    {this.state.garageJobQuote && this.state.garageJobQuote.garage && this.state.garageJobQuote.garage.garage_taxes && this.state.garageJobQuote.garage.garage_taxes.length ?
                      <div className="details">
                        <label>Sub Total</label>
                        <span>

                      {this.state.garageJobQuote ? (Number(this.state.garageJobQuote.totalamount) - Number(this.state.garageJobQuote.discountAmount)).toFixed(2) : ""} {this.state.garageJobQuote && this.state.garageJobQuote.currency ? this.state.garageJobQuote.currency : "AED"}

                                                </span>
                      </div>
                      : ""}
                    {this.state.garageJobQuote && this.state.garageJobQuote.garage && this.state.garageJobQuote.garage.garage_taxes && this.state.garageJobQuote.garage.garage_taxes.length ?
                      <div className="details">
                        <label>VAT ({this.state.garageJobQuote.garage.garage_taxes[0].value} %)</label>
                        <span>
                      {(this.state.garageJobQuote && this.state.garageJobQuote.garage && this.state.garageJobQuote.garage.garage_taxes) ? (this.state.garageJobQuote.garage.garage_taxes[0].value).toFixed(2) : ""} {this.state.garageJobQuote && this.state.garageJobQuote.currency ? this.state.garageJobQuote.currency : "AED"}
                                                </span>
                      </div>
                      : ''
                    }
                    <div className="total">
                      <label>Total</label>
                      <span>
                      {this.state.garageJobQuote && this.state.garageJobQuote.finalAmount ? (this.state.garageJobQuote.finalAmount).toFixed(2) : ""} {this.state.garageJobQuote && this.state.garageJobQuote.currency ? this.state.garageJobQuote.currency : "AED"}
                                                </span>
                    </div>

                    {this.state.garageJobQuote && this.state.garageJobQuote.garage && !this.state.garageJobQuote.garage.garage_taxes &&

                    <div><label className="vat-details">All prices include VAT.</label></div>
                    }
                    <div>
                    </div>
                  </div>

                }
                {jobStatus != 'waiting' && jobStatus != 'applied' ?

                  (jobStatus === 'closed' || jobStatus === 'decline' || jobStatus === 'completed') ?
                    <div className="note-holder">
                      <p>Note:</p>
                      <p>{this.state.addJobeNote ? this.state.addJobeNote  : ' - '}</p>
                    </div>
                    :
                    <div className="note-holder">
                        <TextInput type="text"
                          label="Add Notes"
                          name="name"
                          value={this.state.addJobeNote}
                          onChange={(text) => { this.onQuoteChange(text); }}
                          // onBlur={() => { this.createQuote(null, jobStatus, true, true); }}
                        />
                    </div>
                  :
                  <div className="note-holder">
                      <TextInput type="text"
                        label="Add Notes"
                        name="name"
                        value={this.state.addJobeNote}
                        onChange={(text) => { this.onQuoteChange(text); }}
                      />
                  </div>
                }
              <div className="quotesSection-button">
                {
                  (jobStatus == 'waiting' || jobStatus == 'applied' || jobStatus == 'confirmed') &&
                  <Button
                    btnSize="sm"
                    btnType="label"
                    fontSize={13}
                    label="Decline Job"
                    backgroundColor="transparent"
                    btnCallBack={
                      (e) => {
                        e.preventDefault();
                        this.setState({ showDeclineModal: true})
                        }
                    }
                  />
                }
                {
                  (jobStatus == 'applied' || jobStatus == 'waiting') &&
                  !(_.isEmpty(this.state.userbookingRequestServices)) &&
                  <Button
                    btnSize="sm"
                    fontSize={13}
                    disabled={totalAmount > 0 ?  false : this.state.promotionalOffersIsApproved ? false : true}
                    label={
                      jobStatus == 'waiting' ? "Send Quote" : "Update Quote"
                    }
                    btnCallBack={
                      (e) => {
                        e.preventDefault();
                        this.createQuote(null, jobStatus)
                      }
                    }
                    btnType="quote"
                    isButtonLoading={this.state.isButtonLoading}
                    backgroundColor="#ED3124"
                  />
                }
                {(jobStatus == 'inprogress' || jobStatus == 'confirmed') && <Button btnSize="sm" fontSize={13}
                        btnSize="sm" fontSize={13} label="Update Quote"
                        btnCallBack={(e) => {
                          this.doneInProgQuotesUpdate(e, jobStatus);

                        }}
                        btnType="quote"
                        isButtonLoading={this.state.isDoneButtonLoading}
                        backgroundColor="#ED3124"
                      />}
                {isCompleteCarService && <Button btnSize="sm" fontSize={13} label="Complete Job" btnCallBack={this.completeCarService.bind(this)} btnType="quote" isButtonLoading={this.state.isButtonLoading} backgroundColor="#ED3124" />}
              </div>
              </CustomScroll>
            </div>
          </div>
          </CustomScroll>
        </div>
        {commonReducer.toastMessage && <ToastMessage actions={actions} type={commonReducer.toastType} title={capitalize(commonReducer.toastType)} text={commonReducer.toastMessage} />}
        <div className="messagesSection-view hide" />
        <CustomModal className="decline-modal" showModal={this.state.showDeclineModal} footer="true" title="Decline Job" hideModal={() => this.setState({ showDeclineModal: false, declineReason: '' })} saveText="Decline" submitCallBack={() => { this.declineJob(jobStatus); }}>
          <Modal.Body>
            <div>
              <span className="caption-result">Are you sure you want to Decline this Job?</span>
                  <div className="decline-txt-input">
                    <TextInput
                      type="text"
                      label="Comment"
                      name="Reason"
                      value={this.state.declineReason}
                      onChange={(text) => {
                        this.onDeclineReasonChange(text);
                      }}
                    />
                </div>
                {
                  this.state.showDeclineReasonErrTxt &&
                  <div className=''>
                    <span className="err-decline-txt">should be less than 201 characrers</span>
                  </div>
                }
                <div className="decline-reason-len-box">
                  <span className={this.state.declineReason.length > 200 ? 'err-decline-txt-len' : 'decline-txt-len'}>{this.state.declineReason.length ? this.state.declineReason.length : 0}/200</span>
                </div>
            </div>
          </Modal.Body>
        </CustomModal>
        <CustomModal
          className="decline-modal"
          showModal={this.state.showAddSubCatModal}
          footer="true"
          title="Add Sub Category"
          hideModal={
            () => this.setState({ showAddSubCatModal: false })
          }
          saveText="Add"
          submitCallBack={
            () => {this.handleAdd();}
          }
        >
          <Modal.Body>
            <div>
            {this.state.modalArr && this.state.modalArr.length ?

              map(this.state.modalArr, (category, key) => {
                return(
                    <div key={key}>
                      <span className="checkbox-style checkbox-wrapper">
                        <input  type="checkbox" checked={category.toBeAdded} id={category.name} onChange={(checked) => {this.handleSubCatAdd(category, checked);}}/>
                        <label htmlFor={category.name} className="custom-checkbox-2 custom-checkbox-subcat"></label>
                        <label htmlFor={category.name} className="subcategory-name ">
                          <span>{category.name}</span>
                        </label>
                      </span>
                  </div>
                );
              })

            :
            ''
          }
            </div>

          </Modal.Body>
        </CustomModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/JobDetailsView/QuotesView.jsx